module.exports = __webpack_public_path__ + "fonts/PlayfairItalic.8969f241.ttf";